module.exports = __webpack_public_path__ + "static/img/医院收入运营数据智能体.8c0da6af.png";